import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import Backbone from 'backbone';

import configureStore from './config/configureStore';
import App from './containers/App';
import Router from './routers/Router';

// inject global CSS
// TODO: should refactor out global CSS in favor of private & local styles in the component
import 'react-virtualized/styles.css'; // eslint-disable-line
import './styles/css/bootstrap.min.css';
import './styles/css/index.css';
import './styles/css/antd-overrides.css';

const store = configureStore();
const router = new Router({ store });

render(
  <Provider store={store}>
    <App store={store} router={router} />
  </Provider>,
  document.getElementById('app')
);

Backbone.history.start({ pushState: true });



// WEBPACK FOOTER //
// ./src/index.js